import { dict } from '../dict';

const handleWindowClose = (event: BeforeUnloadEvent): string => {
  event.preventDefault();
  event.returnValue = dict.leaveCallConfirmation;
  return dict.leaveCallConfirmation;
};

export const unblockRoutingChange = (): void => {
  window.removeEventListener('beforeunload', handleWindowClose);
};

export const redirectTo = (url: string): void => {
  unblockRoutingChange();

  window.location.replace(url);
};

export const interceptRoutingChange = (): void => {
  window.addEventListener('beforeunload', handleWindowClose);
};
